import {
  Button,
  MenuItem,
  Select,
  TableCell,
  TableRow,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { ImportedOutgoDetail } from 'types';

type Props = {
  detail: ImportedOutgoDetail;
  onClickUpdateImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
  onClickDeleteImportedOutgoDetail: (updated: ImportedOutgoDetail) => void;
};

const ImportedOutgoDetailRow: React.FC<Props> = ({
  detail,
  onClickUpdateImportedOutgoDetail,
  onClickDeleteImportedOutgoDetail,
}) => {
  const [kind, setKind] = useState(detail.kind);
  const [amount, setAmount] = useState(detail.amount);

  const onUpdate = () => {
    const updated = {
      ...detail,
      kind,
      amount,
    };
    onClickUpdateImportedOutgoDetail(updated);
  };

  const onDelete = () => {
    onClickDeleteImportedOutgoDetail(detail);
  };

  return (
    <TableRow>
      <TableCell>{detail.name}</TableCell>
      <TableCell>
        <Select
          label="種別"
          name="kind"
          value={kind}
          autoWidth
          onChange={(event) => {
            setKind(event.target.value);
          }}
        >
          <MenuItem value="rent">家賃</MenuItem>
          <MenuItem value="food">食費</MenuItem>
          <MenuItem value="commodity">日用品</MenuItem>
          <MenuItem value="hobby">趣味</MenuItem>
          <MenuItem value="communication">通信</MenuItem>
          <MenuItem value="social">交際費</MenuItem>
          <MenuItem value="utility">光熱費</MenuItem>
          <MenuItem value="other">その他</MenuItem>
        </Select>
      </TableCell>
      <TableCell>
        <TextField
          margin="normal"
          required
          label="金額"
          type="number"
          name="amount"
          value={amount}
          onChange={(event) => {
            setAmount(parseInt(event.target.value, 10));
          }}
        />
      </TableCell>
      <TableCell>
        <Button variant="contained" onClick={onUpdate}>
          更新
        </Button>
      </TableCell>
      <TableCell>
        <Button variant="contained" color="error" onClick={onDelete}>
          削除
        </Button>
      </TableCell>
    </TableRow>
  );
};

export default ImportedOutgoDetailRow;
